import React, { useState, useEffect } from "react";
import { Layout, Menu, Button } from "antd";
import {
  HomeOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined, 
  FormOutlined,
  SettingOutlined,
  UnorderedListOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Nav from "../../../components/Nav/Nav";
import sidebarStyles from "../../../components/Sidebar/sidebarStyles.js";

import CustomerService from "../CustomerService";
import GuestHome from "../../../assets/Icons/guesthome.jpg";

const { Sider, Header, Content, Footer } = Layout;

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowWidth;
};

const SupportDash = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 768;

  const desktopSidebarWidth = collapsed ? 80 : 250;
  const contentMarginLeft = isMobile ? 0 : desktopSidebarWidth;

  const menuItems = [
    {
      key: "1",
      icon: <HomeOutlined />,
      label: "Dashboard",
      onClick: () => {
        navigate("/customer-support");
        setMobileOpen(false);
      },
    },
    {
      key: "2",
      icon: <FormOutlined />,
      label: "Reservation",
      onClick: () => {
        navigate("/customer-support/new-reservation");
        setMobileOpen(false);
      },
    },
    {
      key: "3",
      icon: <UnorderedListOutlined />,
      label: "Reservation List",
      onClick: () => {
        navigate("/customer-support/reserve-list");
        setMobileOpen(false);
      },
    },
    {
      key: "4",
      icon: <SettingOutlined />,
      label: "Setting",
      onClick: () => {
        navigate("/customer-support/support-setting");
        setMobileOpen(false);
      },
    },
    { type: "divider" },
    {
      key: "5",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: () => {
        navigate("/logout");
        setMobileOpen(false);
      },
    },
  ];

  const getDefaultSelectedKey = () => {
    const path = location.pathname;
    if (path.includes("new-reservation")) return ["2"];
    if (path.includes("reserve-list")) return ["3"];
    if (path.includes("support-setting")) return ["4"];
    return ["1"];
  };

  return (
    <Layout className="min-h-screen">
      <style>{sidebarStyles}</style>

      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        trigger={null}
        className="hidden md:flex main-sidebar flex-col"
        width={250}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <div className="admin-card flex items-center gap-3">
          <div className="profile-pic-wrapper">
            <img src={GuestHome} alt="Admin Avatar" />
          </div>
          {!collapsed && (
            <div className="admin-info">
              <span className="text-base font-semibold block">GuestHome</span>
              <span className="admin-role block">Customer Support</span>
            </div>
          )}
        </div>
        <Menu
          defaultSelectedKeys={getDefaultSelectedKey()}
          mode="inline"
          items={menuItems}
          inlineCollapsed={collapsed}
        />
      </Sider>

      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 md:hidden"
          onClick={() => setMobileOpen(false)}
        >
          <Sider
            className="h-full main-sidebar shadow-lg flex flex-col"
            width={240}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-4 flex justify-between items-center border-b border-gray-600">
              <span className="text-white font-semibold text-lg">Menu</span>
              <Button
                className="text-white"
                type="text"
                icon={<CloseOutlined />}
                onClick={() => setMobileOpen(false)}
              />
            </div>
            <Menu
              defaultSelectedKeys={getDefaultSelectedKey()}
              mode="inline"
              items={menuItems}
            />
          </Sider>
        </div>
      )}

      <Layout
        className="flex-1 flex flex-col min-h-screen transition-all duration-300"
        style={{ marginLeft: contentMarginLeft }}
      >
        <Header className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center">
            <Button
              className="hidden md:block bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-white rounded-md border-none mr-4"
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
            />
            <Button
              className="md:hidden bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-white rounded-md border-none"
              type="default"
              onClick={() => setMobileOpen(true)}
            >
              <MenuUnfoldOutlined />
            </Button>
          </div>
          <div className="flex-grow">
            <Nav />
          </div>
        </Header>

      
        <Content className="flex-1 p-4 bg-gray-100 dark:bg-gray-800 overflow-y-auto">
          {location.pathname === "/customer-support" && <CustomerService />}
          <Outlet />
        </Content>

        <Footer className="bg-white dark:bg-gray-900 text-center p-4 text-gray-600 dark:text-gray-300">
          GuestHome PLC ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
};

export default SupportDash;
